import { render, staticRenderFns } from "./TemplatePreset.vue?vue&type=template&id=521d30e8&scoped=true&"
import script from "./TemplatePreset.vue?vue&type=script&lang=ts&"
export * from "./TemplatePreset.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatePreset.vue?vue&type=style&index=0&id=521d30e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d30e8",
  null
  
)

export default component.exports